module.exports = __webpack_public_path__ + "img/conbanner.98cab660.png";